/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ForwardInputs */

const en_common_forward = /** @type {(inputs: Common_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward`)
};

const es_common_forward = /** @type {(inputs: Common_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adelante`)
};

/**
* | output |
* | --- |
* | "Forward" |
*
* @param {Common_ForwardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_forward = /** @type {((inputs?: Common_ForwardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ForwardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_forward(inputs)
	return en_common_forward(inputs)
});